import ReactGA from 'react-ga4';
import { env } from './env';

const GA_MEASUREMENT_ID = env.REACT_APP_GOOGLE_ANALYTIC_TRACKING_ID;

export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const logPageView = (page) => {
  ReactGA.send({ hitType: "pageview", page: page, title: page });
};

export const logEvent = (category, action, label, value) => {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
};
